import React, { useEffect, useState } from 'react';
import api from '../services/api';
import FilterableTable from '../components/FilterableTable';
import Toast from '../components/Toast';
import { formatCantitate } from '../utils/format';

export default function Alerte() {
  const [alerte, setAlerte] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  function incarca() {
    setLoading(true);
    api.get('/api/stoc/alerte').then(res => setAlerte(res.data)).finally(() => setLoading(false));
  }

  useEffect(() => { incarca(); }, []);

  async function scoateDinAlerte(a) {
    try {
      await api.put(`/api/stoc/alerte/${a.itemTip}/${a.itemId}/scoate`);
      setToast({ message: 'Scos din alerte - pragul a fost sters din nomenclator', type: 'ok' });
      setAlerte(prev => prev.filter(x => !(x.itemTip === a.itemTip && x.itemId === a.itemId)));
    } catch (err) {
      setToast({ message: err.response?.data?.error || 'Eroare la scoaterea din alerte', type: 'error' });
    }
  }

  if (loading) return <p>Se incarca...</p>;

  const coloane = [
    { key: 'itemTip', label: 'Tip', render: a => a.itemTip === 'MATERIAL' ? 'Materiale' : 'Produs finit' },
    { key: 'cod', label: 'Cod', render: a => a.cod || '-' },
    { key: 'denumire', label: 'Denumire' },
    { key: 'stocTotal', label: 'Stoc total', render: a => `${formatCantitate(a.stocTotal)} ${a.um}` },
    { key: 'pragAlerta', label: 'Prag', render: a => `${formatCantitate(a.pragAlerta)} ${a.um}` },
    { key: 'lipsa', label: 'Lipsa', filterable: false, render: a => `${formatCantitate(a.pragAlerta - a.stocTotal)} ${a.um}` },
    { key: 'actiuni', label: '', filterable: false, render: a => (
      <button type="button" className="btn secondary" onClick={() => scoateDinAlerte(a)}>Scoate din alerte</button>
    ) }
  ];

  return (
    <div>
      <h1>Alerte</h1>

      <div className="card">
        <h2 style={{ marginTop: 0, fontSize: 16 }}>Stoc sub prag ({alerte.length})</h2>
        <FilterableTable columns={coloane} rows={alerte.map((a, i) => ({ ...a, id: i }))} rowClassName={() => 'alerta'} />
      </div>

      <Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />
    </div>
  );
}
